module.exports = __webpack_public_path__ + "static/main5-36353159babf5c9eab3cd899251b3020.png";